import { useRef, useState, FC } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { useAppDispatch } from 'app/store';
import { addParticipantsToCompetitionsThunk } from 'entities/competitions-b2cr/thunk';
import { IAddParticipantsToCompetitions } from 'entities/competitions-b2cr';
import { toast } from 'react-toastify';
import css from './style.module.css';

type ResponseType = IAddParticipantsToCompetitions.Response;

/**
 * Назначить участников с помощью xlsx-файла
 */
const ParticipantsXlsxLoader: FC<{
  competitionId: number;
  refetchParticipants: () => void;
}> = ({ competitionId, refetchParticipants }) => {
  const dispatch = useAppDispatch();
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [loading, setLoading] = useState(false);

  const handleOnChange = async (file: File) => {
    if (!competitionId) return;
    setLoading(true);

    const result = await dispatch(
      addParticipantsToCompetitionsThunk({
        file,
        competition_id: competitionId,
      }),
    );

    const { payload } = result;

    if (!(payload as ResponseType).detail) {
      refetchParticipants();
    }

    if ((payload as ResponseType).detail) {
      const { detail } = payload as ResponseType;

      detail?.map((error) => {
        const { msg } = error;

        toast.error(msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
    }

    setLoading(false);
  };

  return (
    <div className={css.box}>
      <input
        className={css.input}
        ref={inputRef}
        type="file"
        onChange={(e) => {
          if (e.target?.files) {
            handleOnChange(e.target?.files[0]);
            e.target.value = '';
          }
        }}
      />
      <Button
        variant="contained"
        size="medium"
        onClick={() => inputRef.current?.click()}
        disabled={loading}
      >
        Добавить участников (.xlsx)
      </Button>
      {loading ? (
        <div className={css.loader}>
          <CircularProgress size={20} />
        </div>
      ) : null}
    </div>
  );
};

export default ParticipantsXlsxLoader;
